module.exports = __webpack_public_path__ + "img/cycle-4_a_button.02ead417.png";